jQuery(document).ready(function ($) {
	let courses = [];
	let coursesContainer = $(".courses-container");
	let globalResponse = "";

	if (coursesContainer.length) {
		let response = getCoursesByType();
		if (response) {
			response.then((isReady) => {
				if (isReady) {
					appendCoursesSelect(courses);
				}
			});
		} else {
			appendCoursesSelect((arr = []));
		}
	}

	$(document).on("submit", "form.course-form", function (e) {
		e.preventDefault();
		let courseId = $("#courses").val();
		let year = $("#course_year").val();
		let userType = $("#td-type").val();
		if (!courseId || courseId === undefined) {
			$.modal.close();
			return;
		}

		var data = {
			action: "ajax_save_trainee_course",
			course_id: courseId,
			user_id: ajaxOBJ.user_id,
			user_type: userType,
			course_year: year,
			nonce: ajaxOBJ.nonce,
		};

		console.log(data);
		let response = ajaxCall(data);
		response.then((isReady) => {
			if (isReady) {
				location.reload();
			}
		});
	});

	$(document).on("click", ".td-card-title .td-edit, .td-cancel", function () {
		let card = $(this).closest(".td-card");
		card.toggleClass("card-preview");
		let inputs = card.find("input");
		let buttons = card.find(".td-button");
		let selects = card.find(".td-select");
		let is_editable = card.hasClass("card-preview");
		toggleSelects(selects, is_editable);
		toggleInputs(inputs, is_editable);
		toggleButtons(buttons);

		if ($(this).hasClass("td-cancel")) {
			selects.val(selects.data("selected"));
		}
	});

	$(document).on("change", ".td-switch", function () {
		console.log($(this).is(":checked"));
		let field = $(this).data("field");
		var data = {
			action: "ajax_save_private_field",
			field: field,
			value: $(this).is(":checked"),
			nonce: ajaxOBJ.nonce,
		};

		ajaxCall(data);
	});

	// Adding course
	$(document).on("click", ".td-new", function () {
		$("#add-course").modal({
			modalClass: "td-modal",
		});
	});

	// Deleting course
	$(document).on("click", ".td-course-delete", function (e) {
		e.preventDefault();
		let id = $(this).data("course");

		var data = {
			action: "ajax_delete_trainee_course",
			id: id,
			nonce: ajaxOBJ.nonce,
		};

		let response = ajaxCall(data);
		response.then((isReady) => {
			if (isReady) {
				location.reload();
			}
		});
	});

	// mark review spam
	$(document).on("click", ".review-spam", function(e){
		e.preventDefault();
		let review_id = $(this).data("id");
		let _this = $(this);

		var data = {
			action: "ajax_update_review",
			id: review_id,
			column: 'flag',
			value: 'spam',
			nonce: ajaxOBJ.nonce,
		};

		let response = ajaxCall(data);
		response.then((isReady) => {
			if (isReady) {
				location.reload();
			}
		});
	});

	// Replying Review
	$(document).on("click", ".review-reply, .td-review-cancel", function(e){
		e.preventDefault();
		$("form.reply-form").toggleClass("td-hide");
	});

	$(document).on("submit", "form.reply-form", function (e) {
		e.preventDefault();
		let reviewContent = $("#review-reply").val();
		let reviewParentID = $(this).data("parent");
		var data = {
			action: "ajax_save_review",
			user_id: ajaxOBJ.user_id,
			author_id: ajaxOBJ.user_id,
			review_content: reviewContent,
			review_rating: 0,
			review_parent: reviewParentID,
			flag: "reply",
			nonce: ajaxOBJ.nonce,
		};

		console.log(data);
		let response = ajaxCall(data);
		response.then((isReady) => {
			if (isReady) {
				location.reload();
			}
		});
	});

	// Filter Form - Trainee Directory
	$(".filters-form select").on("change", function(e){
		// Construct URLSearchParams object instance from current URL querystring.
		var queryParams = new URLSearchParams(window.location.search);
		// Set new or modify existing parameter value. 
		queryParams.set($(this).data("filter"), $(this).val());

		if ($(this).val() == "") {
			queryParams.delete($(this).data("filter"));
		}
		// Replace current querystring with the new one.
		history.replaceState(null, null, "?" + queryParams.toString());
		$('.filters-form').submit();
	});

	function toggleInputs(inputs, is_editable = false) {
		$.each(inputs, function () {
			$(this).attr("readonly", is_editable);
		});
	}

	function toggleSelects(selects, is_editable = false) {
		$.each(selects, function () {
			$(this).attr("disabled", is_editable);
			$(this).toggleClass("td-disabled");
		});
	}

	function toggleButtons(buttons) {
		$.each(buttons, function () {
			$(this).toggleClass("hide");
		});
	}

	function createCoursesSelect(courses) {
		let select = $("<select>", {
			name: "courses",
			id: "courses",
			required: "required",
		});
		$("<option />", {
			value: "",
			text: "Select Course",
		}).appendTo(select);
		if (courses.length > 0) {
			courses.forEach((course) => {
				$("<option />", {
					value: course.id,
					text: course.course_name,
				}).appendTo(select);
			});
			return select;
		} else {
			return `<p>No data available</p>`;
		}
	}

	function appendCoursesSelect(courses) {
		let select = createCoursesSelect(courses);
		coursesContainer.append(`<label for="courses">Course Name</label>`);
		coursesContainer.append(select);
	}

	function getCoursesByType() {
		if (ajaxOBJ.user_id == 0) {
			return false;
		}
		let type = $("#td-type").val();
		if (!type) {
			return false;
		}
		var data = {
			action: "ajax_get_courses_by_type",
			type: type,
			value: $(this).is(":checked"),
			nonce: ajaxOBJ.nonce,
		};
		return new Promise(function (resolve, reject) {
			$.post(ajaxOBJ.url, data, function (response) {
				if (response.success === true) {
					courses = response.courses;
					resolve(true);
				}
			}).fail(function (xhr, status, error) {
				resolve(false);
				console.log(xhr);
			});
		});
	}

	function ajaxCall(data) {
		return new Promise(function (resolve, reject) {
			$.post(ajaxOBJ.url, data, function (response) {
				if (response.success === true) {
					globalResponse = response;
					resolve(true);
				}
			}).fail(function (xhr, status, error) {
				resolve(false);
				console.log(xhr);
			});
		});
	}
});
